import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { classNames } from "../../utils/helpers";
import s from './Theme.module.css';
/* Context used to store data responsible for switching between modes of a theme */
const ThemeContext = React.createContext({
    colorMode: 'dark',
});
export const ThemeProvider = ({ colorMode, children, className }) => {
    const themeAttribute = colorMode === 'dark' ? 'starc-dark' : 'starc-light';
    const rootClassNames = classNames(s.root, className);
    const value = React.useMemo(() => ({ colorMode: colorMode !== null && colorMode !== void 0 ? colorMode : 'dark' }), [colorMode]);
    return (_jsx(ThemeContext.Provider, { value: value, children: _jsx("div", { className: rootClassNames, "data-st-theme": themeAttribute, children: children }) }));
};
export const useTheme = () => {
    const value = React.useContext(ThemeContext);
    return value;
};
